import { useAuth } from "@/contexts/AuthContext";
import { ROLES, ROLES_LEVELS } from "@/common/permissions";
import { useMemo } from "react";

export const useIsPermitted = (role: ROLES) => {
  const { user } = useAuth();

  const isPermitted = useMemo(() => {    
    if (!user || (!user.role && role !== ROLES.SUPERADMIN)) {
      return false;
    }

    const userRole = user.role;

    const userLevel = ROLES_LEVELS[userRole];
    const requiredLevel = ROLES_LEVELS[role];

    return userLevel <= requiredLevel;
  }, [user?.role, role]);

  return isPermitted;
};
